// @ts-nocheck

// App
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Actions
import ListingEngineActions from 'app/shared/flux/actions/ListingEngineActions';

// Hooks
import { useFilterChange } from 'app/shared/modules/MobileSRP/Header/FilterBar/hooks';

// Misc / utils
import { DEFAULT } from 'app/shared/models/Filter';
import { filterUtils_getFilterPillLabels } from 'app/shared/utils/filterUtils';
import { yieldCallback } from '@zillow/yield-callback';

export const useMobileLogic = () => {
  // Redux
  const dispatch = useDispatch();
  const filter = useSelector((state) => state.filter);
  const { resetFilter } = useFilterChange();

  // React
  const [filterLabelCounts, setFilterLabelCounts] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const filterLabels = filterUtils_getFilterPillLabels(filter);

  const fetchNumListingsExcludedPerFilter = async () => {
    const filterLabelsAndCounts = {};
    /**
     * For each filter pill label, fetch the number of listings that would be present IF
     * the filter was not active!
     *
     * How this works:
     * Take the entire current filter as is, grab the default value for the current
     * filter label in question, and send that off to byCoords to "see" how many
     * properties we're excluding.
     */

    await Promise.all(
      filterLabels.map(async (labelTuple) => {
        const key = labelTuple[0];
        const filterWithKeyReset = Object.assign({}, filter, { [key]: DEFAULT[key] });
        setIsLoading(true);
        const numOfListings = await dispatch(
          ListingEngineActions.fetchListingsByCoordsForFilterPills({ filter: filterWithKeyReset }),
        );

        filterLabelsAndCounts[key] = String(numOfListings);
      }),
    );
    setFilterLabelCounts(filterLabelsAndCounts);
    setIsLoading(false);
  };

  const fetchTotalNumListingsExcluded = async () => {
    await dispatch(ListingEngineActions.fetchExcludedListingsByCoords());
    setIsLoading(false);
  };

  const initialize = () => {
    // Get listings excluded per filter
    fetchNumListingsExcludedPerFilter();

    // Get total listings excluded from all filters
    fetchTotalNumListingsExcluded();
  };

  const handleClearAllFilters = () => yieldCallback(resetFilter());

  const _yieldFilterItemRemoval = yieldCallback((key) => {
    resetFilter({ [key]: DEFAULT[key] });
  });

  const handleFilterItemRemoval = (key) => {
    _yieldFilterItemRemoval(key);
  };

  return {
    initialize,
    handleClearAllFilters,
    handleFilterItemRemoval,
    filterLabels,
    filterLabelCounts,
    isLoading,
  };
};
